import { AuthContext } from '@deltek/specification-client/core/Configurations/AuthContext'
import { useContext, useMemo } from 'react'

export interface ChatInstanceId {
    key: string
}

/**
 * Generates a Chat Instance Id that is isolated per user.
 * @param key Unique identifier for the chat instance
 * @returns ChatInstanceId with a generated key
 */
export const useChatInstanceId = (key?: string): ChatInstanceId => {
    const { currentUserInfo } = useContext(AuthContext)
    const { kpUserId: userId } = currentUserInfo

    const chatInstanceId: ChatInstanceId = useMemo(
        () => ({
            key: `askDelaChatStore-${userId}-${key}`,
        }),
        [userId]
    )

    return chatInstanceId
}
